import React from 'react';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import UserBlock from './UserBlock';
import s from './Users.scss';
const Users = ({ block, deviation: parentDeviation })=>{
    var _block_users;
    const shouldLinkToGallery = block.layout === 0 && block.contentTitleType === 'more-by';
    const linkTo = shouldLinkToGallery ? 'gallery' : undefined;
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block,
        headerClassName: s['header']
    }, /*#__PURE__*/ React.createElement("div", null, (_block_users = block.users) === null || _block_users === void 0 ? void 0 : _block_users.map(({ user, deviations })=>user && deviations && /*#__PURE__*/ React.createElement(UserBlock, {
            key: user.userId,
            parentDeviation: parentDeviation,
            user: user,
            deviations: deviations,
            linkTo: linkTo
        }))));
};
Users.displayName = 'Users';
export default Users;
